// extracted by mini-css-extract-plugin
export default {"zoomModal":"lda-z"};